import React, { Component } from 'react';

const NoData = ({ isShowNodata }) => {
    if (isShowNodata) {
        return (
            <div>
                <div className="no-data"></div>
                <div className="tips">该租期下同城其他门店暂无此车型库存</div>
            </div>
          );
    }
    return null;
}

export default NoData;